<template>
  <div class="BuildABox">
    <!--PAGE 2 -->
    <div class="build-wrapper">
      <div class="builder-content-wrapper">
        <div id="scroll-container" class="builder-experience-container no-scrollbar">
          <div class="full-view-header header-steps-wrapper flex flex-align-center flex-justify-center pd-2rem gap-1vw">
            <div class="header-steps-container m-w-100 gap-1vw w-auto bg-white rounded-button shadow-dark flex flex-align-center flex-justify-between p-l-2rem">
              <p class="steps body-base flex flex-align-center flex-justify-center p-r-1rem">
                <span class="p-r-05rem">STEP {{currentStep}} OF 4:</span>
                <span class="dot">
                  <span :class="1 <= currentStep ? 'selected' : ''"></span>
                </span>
                <span class="dot">
                  <span :class="2 <= currentStep ? 'selected' : ''"></span>
                </span>
                <span class="dot">
                  <span :class="3 <= currentStep ? 'selected' : ''"></span>
                </span>
                <span class="dot">
                  <span></span>
                </span>
              </p>
              <div class="steps-text body-base flex flex-align-center gap-1vw desktop">
                <p :class="1 == currentStep ? 'selected' : ''">Pick Gifts</p>
                <div class="step-arrow"> > </div>
                <p :class="2 == currentStep ? 'selected' : ''">Select Your Box</p>
                <div class="step-arrow"> > </div>
                <p :class="3 == currentStep ? 'selected' : ''">Write Your Card</p>
                <div class="step-arrow"> > </div>
                <p>Shipping</p>
              </div>
              <p class="body-base mobile">{{ stepText }}</p>
              <button :disabled="!canNext" @click=" currentStep == 3 ? openCart() : changePage(true)" class="hb-btn primary slim p-l-unset p-r-unset">
                <span class="p-r-2rem p-l-2rem desktop">Next Step ></span>
                <span class="p-r-1rem p-l-1rem mobile">Next ></span>
              </button>
            </div>
          </div>
          <div id="header-actions" class="full-view-header header-actions-wrapper bg-white flex flex-align-center flex-justify-between gap-1vw p-l-2rem p-r-2rem p-t-1rem p-b-1rem">
            <div class="desktop flex flex-align-center flex-justify-between gap-1vw w-100">
              <div class="header-action-section flex-1 flex flex-align-center flex-justify-between gap-1vw">
                <button class="body-base color-link font-bold hov-underline flex-shrink-0" @click="changePage(false)">&lt; Back</button>
                <div v-if="currentStep != 2" class="buttons-container w-100 flex flex-align-center gap-1vw">
                  <button @click="showFilters()" class="hb-btn thick wp-nowrap link slim filters flex flex-align-center flex-justify-between gap-05vw">
                    <img class="purple h-auto hov-primary-img" width="15px" height="15px" src="https://cdn.shopify.com/s/files/1/1363/8433/files/filter_purple.svg?v=1723141690"/>
                    <img class="purple h-auto hov-img" width="15px" height="15px" src="https://cdn.shopify.com/s/files/1/1363/8433/files/filter_white.svg?v=1749590428"/>
                    Filters 
                    <span v-if="!selectedCardsOccasions.includes('View All')">({{ selectedCardsOccasions.length }})</span>
                  </button>
                  <button v-if="currentStep == 1" class="hb-btn thick wp-nowrap link slim filters flex flex-align-center flex-justify-between gap-05vw" @click="showSort()">
                    <img width="15px" height="10px" class="h-auto hov-primary-img" src="https://cdn.shopify.com/s/files/1/1363/8433/files/sort.svg?v=1749479130"/>
                    <img width="15px" height="10px" class="h-auto hov-img" src="https://cdn.shopify.com/s/files/1/1363/8433/files/sort_white.svg?v=1749590429"/>
                    Sort Products
                  </button>
                </div>
              </div>
              <div class="header-action-section flex-1 flex flex-align-center flex-justify-center gap-1vw">
                <p class="body-base step-text wp-nowrap">{{ currentCopy }}</p>
                <p class="steps body-base flex-align-center flex-justify-center p-r-1rem flex-shrink-0">
                  <span class="p-r-05rem flex-shrink-0">STEP {{currentStep}} OF 4:</span>
                  <span class="dot">
                    <span :class="1 <= currentStep ? 'selected' : ''"></span>
                  </span>
                  <span class="dot">
                    <span :class="2 <= currentStep ? 'selected' : ''"></span>
                  </span>
                  <span class="dot">
                    <span :class="3 <= currentStep ? 'selected' : ''"></span>
                  </span>
                  <span class="dot">
                    <span></span>
                  </span>
                </p>
              </div>
              <div class="header-action-section between-sticky flex-1 flex flex-align-center flex-justify-end gap-1vw">
                <button :disabled="!canNext" @click=" currentStep == 3 ? openCart() : changePage(true)" class="hb-btn primary p-l-unset p-r-unset sticky">
                  <span class="p-r-1rem p-l-1rem desktop">Next Step ></span>
                  <span class="p-r-1rem p-l-1rem mobile">Next ></span>
                </button>
                <VDropdown
                  :distance="6"
                >
                  <button class="leave-builder cursor-pointer gap-05vw body-base color-link flex flex-align-center flex-justify-center" v-tooltip="{ content: 'Save your selections for 24 hours.<br/> Inventory subject to availability', html: true }" @click="leaveBuilder">
                    <span class="color-link font-bold">{{headerText}} </span>
                    <img width="20" height="20" src="https://cdn.shopify.com/s/files/1/1363/8433/files/save_cart_1.svg?v=1749479131" alt="save cart">
                  </button>
                  <template #popper>
                    <p>
                      Saved!
                    </p>
                  </template>
                </VDropdown>
              </div>
            </div>
            <div class="mobile flex flex-align-center flex-justify-between gap-1vw flex-column w-100">
              <div class="header-action-section flex-1 flex flex-align-center flex-justify-center gap-1vw w-100">
                <button class="body-base color-link font-bold hov-underline flex-shrink-0 flex-1" @click="changePage(false)">&lt; Back</button>
                <p class="body-base step-text wp-nowrap flex-2">{{ currentMobileCopy }}</p>
                <p class="steps body-base flex-align-center flex-justify-center p-r-1rem flex-shrink-0">
                  <span class="p-r-05rem flex-shrink-0">STEP {{currentStep}} OF 4:</span>
                  <span class="dot">
                    <span :class="1 <= currentStep ? 'selected' : ''"></span>
                  </span>
                  <span class="dot">
                    <span :class="2 <= currentStep ? 'selected' : ''"></span>
                  </span>
                  <span class="dot">
                    <span :class="3 <= currentStep ? 'selected' : ''"></span>
                  </span>
                  <span class="dot">
                    <span></span>
                  </span>
                </p>
                <div class="flex-1 flex flex-align-center flex-justify-end">
                  <button :disabled="!canNext" @click=" currentStep == 3 ? openCart() : changePage(true)" class="hb-btn primary p-l-unset p-r-unset sticky">
                    <span class="p-r-1rem p-l-1rem mobile">Next ></span>
                  </button>
                  <VDropdown
                  :distance="6"
                >
                  <button class="leave-builder cursor-pointer gap-05vw body-base color-link flex flex-align-center flex-justify-center noStick" v-tooltip="{ content: 'Save your selections for 24 hours.<br/> Inventory subject to availability', html: true }" @click="leaveBuilder">
                    <span class="color-link font-bold">Save </span>
                    <img width="20" height="20" src="https://cdn.shopify.com/s/files/1/1363/8433/files/save_cart_1.svg?v=1749479131" alt="save cart">
                  </button>
                  <template #popper>
                    <p>
                      Saved!
                    </p>
                  </template>
                </VDropdown>
                </div>
              </div>
              <div class="header-action-section w-100 flex flex-align-center flex-justify-between">
                <div class="buttons-container w-100 flex flex-align-center gap-1vw">
                  <button v-if="currentStep != 2" @click="showFilters()" class="hb-btn link slim filters flex flex-align-center flex-justify-between gap-05vw">
                    <img class="purple h-auto" width="15px" height="15px" src="https://cdn.shopify.com/s/files/1/1363/8433/files/filter_purple.svg?v=1723141690"/>
                    Filters 
                    <span v-if="!selectedCardsOccasions.includes('View All')">({{ selectedCardsOccasions.length }})</span>
                  </button>
                  <button v-if="currentStep == 1" class="hb-btn link slim filters flex flex-align-center flex-justify-between gap-05vw" @click="showSort()">
                  <img width="15px" height="10px" class="h-auto" src="https://cdn.shopify.com/s/files/1/1363/8433/files/sort.svg?v=1749479130"/>Sort Products</button>
                </div>
                <VDropdown
                  :distance="6"
                >
                  <button class="leave-builder cursor-pointer gap-05vw body-base color-link flex flex-align-center flex-justify-center sticky" v-tooltip="{ content: 'Save your selections for 24 hours.<br/> Inventory subject to availability', html: true }" @click="leaveBuilder">
                    <span class="color-link font-bold">Save </span>
                    <img width="20" height="20" src="https://cdn.shopify.com/s/files/1/1363/8433/files/save_cart_1.svg?v=1749479131" alt="save cart">
                  </button>
                  <template #popper>
                    <p>
                      Saved!
                    </p>
                  </template>
                </VDropdown>
              </div>
            </div>
          </div>
          <Page3 ref="giftsComponent" @leavebuilder="leaveBuilder" @changepage="changePage($event)" v-if="currentPage == 1" @gostep="goStep($event)"></Page3>
          <Page4 @changepage="changePage($event)" v-if="currentPage == 2"></Page4>
          <Page5 ref="cardComponent" @changepage="changePage($event)" @gotoaddonselection="goToAddonSelection" :currentPage="currentPage" v-if="currentPage > 2" @opencart="openCart()"></Page5>
        </div>
      </div>
      <SideCartNew 
        ref="outSideCart"
        v-show="currentStep > 1"
        :isSticking="isSticking"
        :step="currentStep"
        :fromCard="fromCard"
        @changepage="changePage($event)" 
        @bundle="bundle($event)"
        @gostep="goStep($event)"
        @cardwarning="cardWarning($event)"
      />
      <SideCartMobile 
        v-if="selectedAddonProducts.length > 0" 
        @changepage="changePage($event)" 
        :step="currentStep"
        @bundle="bundle"
        />
    </div>
    <OOSPopUp
    v-if="oosIsActive"
    :oosProducts="noStockItems" 
    :firstStateProducts="currentStateSelectedAddons"
    :fromSavedCart="fromSavedCart"
    :fromCurated="fromCurated"
    @goback="closeOOSPopUp"
    @continuesaved="continueSaved"
    @continuecurated="continueCurated"
    />
  </div>
</template>
<script>
import Page1 from './components/Page1.vue';
import Page3 from './components/Page3.vue';
import Page4 from './components/Page4.vue';
import Page5 from './components/Page5.vue';
import OOSPopUp from './components/OOSPopUp.vue'
import SideCartNew from './components/SideCartNew.vue'
import SideCartMobile from './components/Step2Mobile/SideCartMobile.vue';
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';

require('dotenv').config();

export default {
  components: {
    Page1,
    Page3,
    Page4,
    Page5,
    OOSPopUp,
    SideCartNew,
    SideCartMobile
  },
  watch:{
    currentCapacity:{
      handler(val, oldVal){
        if(val > oldVal && this.selectedBoxProduct){
          if(parseInt(this.selectedBoxProduct.variants[0].option1) < val)
            this.$store.commit('updateSelectedMainProduct', null);
        }
      },
    }
  },
  data() {
    return {
      currentPage: 1,
      noStockItems: [],
      oosIsActive: false,
      fromSavedCart: false,
      fromCurated: false,
      currentStateSelectedAddons: [],
      currentTime: new Date().getTime() / 100,
      isSticking: false,
      fromCard: false,
    }
  },
  computed: {
    ...mapGetters([
      'selectedOccasion',
      'addonProducts',
      'selectedAddonProducts',
      'selectedCardsOccasions',
      'currentCapacity',
      'selectedBoxProduct',
      'selectedCardProduct',
      'cardHasMessage'
    ]),
    canNext(){
      if(this.currentStep == 1 && this.selectedAddonProducts.length == 0){
        return false
      }
      else if (this.currentStep == 2 && !this.selectedBoxProduct){
        return false;
      }
      else if(this.currentStep == 3 && !this.selectedCardProduct)
        return false;

      return true
    },
    nextError(){
      if (this.currentStep == 2){
        return `<p class="title">Select a box to continue</p>`;
      }
      else if(this.currentStep == 3)
        return `<p class="title">Select a card to continue</p>`;

      return false
    },
    currentStep(){
      if(this.currentPage < 4)
        return this.currentPage;
      else {
        return 3
      }
    },
    currentCopy(){
      if(this.currentPage > 2){
        return "We will handwrite your message for you"
      }
      else if(this.currentPage == 2){
        return "Dont worry, these will fit your items perfectly!"
      }
      else if(this.currentPage == 1){
        return "Pick gifts they will love"
      }

      return ""
    },
    currentMobileCopy(){
      if(this.currentPage > 2){
        return "We will handwrite your message"
      }
      else if(this.currentPage == 2){
        return "These will fit your items perfectly!"
      }
      else if(this.currentPage == 1){
        return "Pick gifts they will love"
      }

      return ""
    },
    headerText(){
      return "Save Your Box"
    },
    breadcrumbText(){
      return `All products > ${this.selectedOccasion}`
    },
    stepText(){
      if(this.currentPage > 2){
        return "Write Card"
      }
      else if(this.currentPage == 2){
        return "Select Box"
      }
      else if(this.currentPage == 1){
        return "Pick Gifts"
      }

      return ""
    }
  },
  methods: {
    changePage(increment) {
      if(!this.canNext && increment){
        this.showErrorModal();
        return;
      }
      window.scrollTo({ top: 0, behavior: 'auto' });
      document.getElementById('PageContainer')?.scrollTo({ top: 0, behavior: 'auto' });
      this.logTimeSpent();
      if(increment){
        if(this.currentPage == 1){
            this.currentPage++;
        }
        else
          this.currentPage++;
      }
      else{
        if(this.currentPage == 1){
          location.href = "/pages/giftboxbuilder"
        }
        this.currentPage--;
      }
      this.logStepNavigation(`Step ${this.currentStep}`);
      this.adjustHeaderandFooter();
    },
    goToAddonSelection(){
      this.currentPage = 1;
    },
    goStep(event){
      this.currentPage = event;
      if(this.currentPage == 1){
        this.$nextTick(() => {
          let container = document.getElementById("jump1");
          container.scrollIntoView();
        })
      }
    },
    cardWarning(){
      if(this.currentPage == 3){
        this.currentPage = 4;
      }
      this.$store.commit('setShowCardAlert', true );
      this.showErrorModal(`<p class="title">Please write your card message</p>`)
    },
    leaveBuilder(){
      var localProducts = this.selectedAddonProducts.filter(x => x.tags.every(x => !x.includes("QTYMIN"))).map((x) => {
        return {id: x.id ,v:x.variants[0].id,q: x.quantity}
      });
      localStorage.setItem('totalAddons',JSON.stringify(localProducts));
    },
    adjustHeaderandFooter(){
      const buildBox = document.getElementById('build-a-box');
      const footer = document.getElementById('shopify-section-footer');
      const header = document.getElementById('shopify-section-header');
      const ticker = document.getElementById('ticker');

      if (this.currentPage > 0) {
        if (buildBox) buildBox.style.overflow = 'hidden';
        if (footer) footer.style.display = 'none';
        if (header) header.style.display = 'none';
        if (ticker) ticker.style.display = 'none';
      } else {
        if (buildBox) buildBox.style.overflow = 'auto';
        if (footer) footer.style.display = '';
        if (header) header.style.display = '';
        if (ticker) ticker.style.display = '';
      }
    },
    closeOOSPopUp(){
      this.fromSavedCart = false;
      this.fromCurated = false;
      this.noStockItems = [];
      this.oosIsActive = false;
      this.currentStateSelectedAddons = [];
    },
    continueSaved(){
      this.closeOOSPopUp();
      this.currentPage = 3;
      //this.adjustHeaderandFooter();
    },
    continueCurated(){
      this.closeOOSPopUp();
      this.changePage(true);
    },
    oosCurated(event){
      this.currentStateSelectedAddons = JSON.parse(JSON.stringify(this.selectedAddonProducts));
      this.fromSavedCart = false;
      this.fromCurated = true;
      this.noStockItems = event;
      this.oosIsActive = true;
    },
    logStepNavigation(label){
      ga('send', {
        hitType: 'event',
        eventCategory: 'Build A Box',
        eventAction: 'Navigation',
        eventLabel: label
      });
    },
    logTimeSpent(){
      let actualTime = new Date().getTime() / 100;
      ga('send', {
        hitType: 'event',
        eventCategory: 'Build A Box',
        eventAction: `Time Step ${this.currentStep}`,
        eventLabel: actualTime - this.currentTime,
      });
      this.currentTime = actualTime;
    },
    openCart(){
      this.fromCard = true;
      this.$refs.outSideCart.expandCart(true);
    },
    bundle(event){
      if(!this.canNext && increment){
        this.showErrorModal();
        return;
      }
      this.$refs.cardComponent.bundle(event);
    },
    showErrorModal(error = null){
      Swal.fire({
        iconHtml: `<img src="https://cdn.shopify.com/s/files/1/1363/8433/files/error_icon_2a88e148-df0e-480c-85b8-89b7d9d6e5ba.svg?v=1741881886" class="alert-icon"/>`,
        html: error || this.nextError,
        confirmButtonText: 'Go Back',
        customClass:{
            container:"swal-custom-container",
            popup: "swal-custom-popup-3",
            title:"swal-title",
            confirmButton: "happybox-button green border",
        },
        buttonsStyling: false,
      });
    },
    showSort(){
      this.$refs.giftsComponent.showSort();
    },
    showFilters(){
      if(this.currentStep == 1){
        this.$refs.giftsComponent.showFilters();
      }
      else if (this.currentStep == 3){
        this.$refs.cardComponent.showFilters()
      }
    },
  },
  beforeMount() {},
  mounted() {
    var editBox = JSON.parse(localStorage.getItem("editBox"));
    if(editBox){
      this.changePage(true);
    }
    const el = document.getElementById("header-actions")
    const observer = new IntersectionObserver( 
      ([e]) => {
        e.target.classList.toggle("isSticky", e.intersectionRatio < 1);
        this.isSticking = e.intersectionRatio < 1;
      },
      { threshold: [1] }
    );
    observer.observe(el);
  },
  destroy() {
  }
}
</script>

<style scoped>
.builder-header{
  width: 100%;
  position: relative;
}

.builder-header .header-main{
  width: 100%;
}

.builder-header .floating-container{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
}

.builder-header.box .floating-container{
  left: 30%;
  width: 20%;
}

.builder-header.card .floating-container{
  left: 30%;
  width: 20%;
  transform: rotate(5deg);
}

.builder-header.card .floating-container .arrow-4{
  position: absolute;
  bottom: 15%;
  width: 5%;
  transform: rotate(50deg) scaleX(-1);
  left: 5%;
}

.builder-header.box .floating-container .arrow-1{
  position: absolute;
  width: 5%;
  transform: rotate(115deg);
  left: 20%;
  top: 30%;
}

.builder-header.box .floating-container .arrow-2{
  position: absolute;
  width: 5%;
  transform: rotate(90deg);
  left: 17%;
  bottom: 25%;
}

.builder-header.box .floating-container .arrow-3{
  position: absolute;
  width: 5%;
  transform: rotate(-90deg);
  right: 17%;
  bottom: 30%;
}

.builder-header .floating-container .title{
  font-size: 3vw;
  line-height: .5;
  font-family: Palmer Lake Print;
  text-align: center;
}

@media screen and (max-width: 767px){
  .builder-header .floating-container .title{
    font-size: 8vw;
  }

  .builder-header.box .floating-container{
    left: 50%;
    justify-content: flex-start;
    padding-top: 7%;
    transform: rotate(5deg);
  }

  .builder-header.box .floating-container .arrow-1{
    width: 12.5%;
    left: -25%;
    top: 35%;
    transform: rotate(90deg);
  }
  .builder-header.box .floating-container .arrow-2{
    width: 12.5%;
    bottom: 15%;
    left: 35%;
    transform: rotate(15deg) scaleX(-1);
  }
  .builder-header.box .floating-container .arrow-3{
    width: 12.5%;
    right: -20%;
    bottom: unset;
    top: 25%;
  }

  .builder-header.card .floating-container{
    left: 35%;
    width: 50%;
    transform: rotate(5deg);
    padding-top: 5%;
    justify-content: flex-start;
  }

  .builder-header.card .floating-container .arrow-4{
    left: 15%;
    width: 7%;
    transform: rotate(40deg) scaleX(-1);
  }
}


</style>

<style>

#shopify-section-footer,#shopify-section-header,#ticker{
  display: none;
}
.global-spinner-container{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(0,0,0,0.3);
  position: fixed;
  height: 100%;
  z-index: 999;
  top: 0;
  right: 0;
  left: 0;
}

.global-spinner-container p{
  font-size: 32px;
  color: white !important;
  font-weight: bold;
  text-align: center;
}

.global-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-left-color: #09f;
  animation: spin 1s ease infinite;
}

.promotion{
  width: 100%;
  position: relative;
}

.promotion img{
  width: 100%;
  border-radius: 8px;
}

.promotion .floating-container{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  top: 0;
  bottom: 0;
  padding: 5%;
}

.promotion .floating-container .title{
  font-size: 2.5vw;
  font-family: Founders Grotesk,sans-serif;
  line-height: 1;
  color: #fff;
  padding-right: 12%;
  margin-bottom: 0.5rem;
}

.promotion .floating-container .subtitle{
  font-size: 1vw;
  color: white;
  margin-bottom: 0.5rem;
}

.promotion .floating-container .subtitle span{
  font-style: italic;
  color: white;
}

.promotion .floating-container .happybox-button{
  width: 100%;
}

.builder-header .breadcrumb{
  color: #0f0c38;
  text-decoration: underline;
  position: absolute;
  top: 0%;
  left: 5%;
  z-index: 1;
  display: none;
}

.builder-header .breadcrumb > * {
  color: #0f0c38;
  text-decoration: underline;
  font-weight: bold;
}

.BuildABox .next-error-modal{
  width: 50%;
  background-color: white;
  position: fixed;
  left: 25%;
  padding: 5% 2.5%;
  top: 30%;
  border-radius: 8px;
  border: 1px solid #D6D6D6;
  box-shadow: 0 0 3px 0px #00000050;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.BuildABox .next-error-modal img{
  width: 4vw;
}

.BuildABox .next-error-modal p{
  font-size: 2vw;
  font-weight: bold;
}

@media screen and (max-width: 767px){
  .global-spinner-container p{
    font-size: 27px;
  }
  .promotion img{
    height: 100%;
    object-fit: cover;
  }

  .promotion .floating-container .happybox-button{
    width: 100%;
    padding: 2%;
  }

  .promotion .floating-container .title{
    font-size: 5vw;
    width: 100%;
  }

  .promotion .floating-container .subtitle{
    font-size: 2vw;
    width: 100%;
    text-align: left;
  }

  .builder-header .breadcrumb{
    top: 7.5%;
    display: block;
  }

  .BuildABox .next-error{
    font-size: 4vw;
    bottom: calc(50% - 2vw);
    left: 25%;
    width: 50%;
  }
}
</style>